import { Controller } from "@hotwired/stimulus"

// Handles resize dragging for the chat context panel.
// Attached to the resize handle element inside the panel.
export default class extends Controller {
  static values = { min: { type: Number, default: 300 } }

  connect() {
    this.panel = this.element.closest("#chat-context-panel")
    if (!this.panel) return

    this.#restoreWidth()
    this.onMouseDown = this.#startResize.bind(this)
    this.element.addEventListener("mousedown", this.onMouseDown)
  }

  disconnect() {
    if (this.onMouseDown) {
      this.element.removeEventListener("mousedown", this.onMouseDown)
    }
    if (this.#resizeCleanup) {
      this.#resizeCleanup()
      this.#resizeCleanup = null
    }
  }

  #resizeCleanup = null

  #restoreWidth() {
    if (window.innerWidth < 1024) return

    const saved = localStorage.getItem("chat-panel-width")
    const parsed = parseInt(saved, 10)
    if (parsed >= this.minValue && parsed <= window.innerWidth * 0.5) {
      this.panel.style.width = parsed + "px"
    } else {
      this.panel.style.width = "400px"
    }
  }

  #startResize(e) {
    e.preventDefault()
    document.body.style.cursor = "col-resize"
    document.body.style.userSelect = "none"

    const panel = this.panel
    const min = this.minValue

    const onMove = (ev) => {
      const w = Math.max(min, Math.min(window.innerWidth * 0.5, window.innerWidth - ev.clientX))
      panel.style.width = w + "px"
    }

    this.#resizeCleanup = () => {
      document.body.style.cursor = ""
      document.body.style.userSelect = ""
      document.removeEventListener("mousemove", onMove)
      document.removeEventListener("mouseup", onUp)
    }

    const onUp = () => {
      this.#resizeCleanup()
      this.#resizeCleanup = null
      localStorage.setItem("chat-panel-width", parseInt(panel.style.width))
    }

    document.addEventListener("mousemove", onMove)
    document.addEventListener("mouseup", onUp)
  }
}
